module.exports = __webpack_public_path__ + "static/media/btn_refresh_nor.3b2fcd75.svg";